const installment = () => {

    $('.installment-guide').click(function () {
        if (!$(this).parent().hasClass('selected')) {
            $('.installment-list>li.selected').removeClass('selected');
            $('.installment-guide-container.expanded').removeClass('expanded');

            $(this).parent().addClass('selected');
            var elementId = $(this).attr('rel');
            $('#' + elementId).addClass('expanded');
        }
    });

    $('.installment-guide-container a.close').click(function () {
        $('.installment-list>li.selected').removeClass('selected');
        $('.installment-guide-container.expanded').removeClass('expanded');
    });
}


export {
    installment
};
